//
//
//
//
//
//


import { BSpinner } from 'bootstrap-vue'

export default {

    name: 'Spinner',

    components: { BSpinner },

    props: {
        triggerScroll: {
            type: Boolean,
            default: false
        }
    },

    created() {
        if(process.client && this.triggerScroll) {
            this.$nuxt.$nextTick(() => this.$nuxt.$emit('triggerScroll'))
        }
    },

    activated() {
        if(process.client && this.triggerScroll) {
            this.$nuxt.$nextTick(() => this.$nuxt.$emit('triggerScroll'))
        }
    }
}

